export class DpsFilterIdName {
  id: any;
  name: string;
  crossLink: string;
}
